<script setup>
  import Hft_SectionWrapper from '@/components/microsites/HeadingForTomorrow/components/Hft_SectionWrapper.vue'
</script>

<template>
  <Hft_SectionWrapper class="m-headingForT-hero" :style="backgroundStyle">
    <div class="m-headingForT-hero__content-bg"></div>
    <div class="m-headingForT-hero__content">
      <img class="m-headingForT-hero__logo" src="@/assets/images/microsites/headingfortomorrow/hero/logo.png" alt="" />
      <div class="m-headingForT-hero__t">
        The Blue Hole comes to MapleStory with DAVE THE DIVER, new HEXA Mastery nodes unlock greater power for your
        favorite skills, and Althea’s Saga continues with the next GMS-exclusive Ride or Die Event!
      </div>
      <div class="m-headingForT-hero__video">
        <iframe
          src="https://www.youtube.com/embed/X3q5cfpGO0A"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
      <!--<Hft_PlayNow v-ga-event="'Play Now'" class="m-headingForT-hero__play" />-->
    </div>
    <div class="m-headingForT-hero__patch-note-btns">
      <a
        v-ga-event="'Patch Note 260 Link Btn'"
        href="https://www.nexon.com/maplestory/news/update/27513/v-260-stargazer-patch-notes"
        target="_blank"
        class="m-headingForT-hero__patch-note-btn"
      >
      </a>
      <a
        v-ga-event="'Patch Note 261 Link Btn'"
        href="https://www.nexon.com/maplestory/news/update/28137"
        target="_blank"
        class="m-headingForT-hero__patch-note-btn m-headingForT-hero__patch-note-btn--261"
      >
      </a>
    </div>

    <div class="m-headingForT-hero__scoll-iron"></div>
  </Hft_SectionWrapper>
</template>

<style></style>

<style lang="scss" scoped>
  @use '@/assets/scss/microsites/headingfortomorrow/variables.scss' as *;

  .m-headingForT-hero {
    position: relative;
    font-size: 0.9vw;
    z-index: 5;
    height: 55.9vw;
    &:after {
      display: none;
    }
  }

  .m-headingForT-hero__video {
    border: 3px solid #ffd02d;
    background: #0f648d;
    display: inline-block;
    position: relative;
    z-index: 10;
    width: 41vw;
    height: 23vw;
    border-radius: 10 px;
    margin: 0 auto 2vw;
    overflow: hidden;
    iframe {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .m-headingForT-hero__content-bg {
    position: absolute;
    top: 0;
    left: 0vw;
    width: 100%;
    height: 100%;
    background: #292929;
    background: url('~@/assets/images/microsites/headingfortomorrow/hero/bg.gif') no-repeat center top / 100% auto;
  }

  .m-headingForT-hero__content {
    position: absolute;
    top: 2.3vw;
    left: 26%;
    transform: translateX(-50%);
    width: 45vw;
    text-align: center;
    z-index: 1;
    display: flex;
    flex-direction: column;
  }

  .m-headingForT-hero__logo {
    width: 30vw;
    margin: 0 auto 0.5vw;
    height: auto;
  }

  .m-headingForT-hero__t {
    width: 34vw;
    color: white;
    font-weight: bold;
    text-shadow: 0px 0px 4px #191b3d, 0px 0px 4px #191b3d, 0px 0px 4px #191b3d, 0px 0px 4px #191b3d;
    margin: 0 auto 1vw;
  }

  .m-headingForT-hero__cta {
    /* cursor: pointer;
    width: 17vw;
    height: 5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/hero/cta-btn/btn-bg.png') no-repeat center center /
      100% auto;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    font-size: 2vw;
    transition: background 0.3s;
    &:hover,
    &:after {
      content: '';
      background-image: url('~@/assets/images/microsites/headingfortomorrow/hero/cta-btn/btn-bg-hover.png');
    } */
  }
  .m-headingForT-hero__patch-note-btns {
    position: absolute;
    bottom: 9vw;
    left: 26%;
    transform: translateX(-50%);
    z-index: 10;
    cursor: pointer;
    display: flex;
    gap: 1.5vw;
  }
  .m-headingForT-hero__patch-note-btn {
    width: 18vw;
    height: 2.5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/hero/patch-note-btn/patch-note-btn.png') no-repeat
      center center / 100% auto;
    transition: background 0.3s;
    &:hover,
    &:after {
      content: '';
      background-image: url('~@/assets/images/microsites/headingfortomorrow/hero/patch-note-btn/patch-note-btn-hover.png');
    }
  }
  .m-headingForT-hero__patch-note-btn--261 {
    background: url('~@/assets/images/microsites/headingfortomorrow/hero/patch-note-btn/patch-note-btn-261.png')
      no-repeat center center / 100% auto;
    transition: background 0.3s;
    &:hover,
    &:after {
      content: '';
      background-image: url('~@/assets/images/microsites/headingfortomorrow/hero/patch-note-btn/patch-note-btn-261-hover.png');
    }
  }

  .m-headingForT-hero__scoll-iron {
    width: 2.3vw;
    height: 3.5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/hero/scroll-icon.png') no-repeat center center /
      100% auto;
    position: absolute;
    bottom: 3vw;
    left: 50%;
    transform: translateX(-50%);
    &::after,
    &::before {
      content: '';
      position: absolute;
      width: 1vw;
      height: 0.8vw;
      left: 50%;
      transform: translateX(-50%);
      background: url('~@/assets/images/microsites/headingfortomorrow/hero/scroll-icon-inner.png') no-repeat center
        center / 100% auto;
    }
    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    &::after {
      bottom: 45%;
      animation: fadeIn 1.2s 0.3s both infinite;
    }
    &::before {
      bottom: 25%;
      animation: fadeIn 1.2s 0.4s both infinite;
    }
  }

  .tablet {
    .m-headingForT-hero {
      height: 105.5vw;
    }
    .m-headingForT-hero__logo {
      width: 50vw;
      margin-bottom: 2w;
    }
    .m-headingForT-hero__t {
      width: 69vw;
      margin-bottom: 2vw;
    }
    .m-headingForT-hero__content {
      width: 72%;
      top: 3vw;
      left: 50%;
      transform: translateX(-50%);
    }
    .m-headingForT-hero__video {
      width: 52vw;
      height: 29vw;
      margin-bottom: 3vw;
    }
    .m-headingForT-hero__content-bg {
      background: url('~@/assets/images/microsites/headingfortomorrow/hero/bg-tablet.jpg') no-repeat center bottom /
        100% auto;
    }

    .m-headingForT-hero__scoll-iron {
      bottom: 11.5vw;
      width: 4.6vw;
      height: 6.9vw;
      &:before,
      &:after {
        width: 1.5vw;
        height: 1.8vw;
      }
    }
    .m-headingForT-hero__patch-note-btns {
      left: 50vw;
      bottom: 36.5vw;
    }
    .m-headingForT-hero__patch-note-btn {
      width: 37vw;
      height: 5vw;
    }
  }
  .mobile {
    .m-headingForT-hero {
      height: 180.5vw;
      &:after {
        display: block;
      }
    }
    .m-headingForT-hero__content-bg {
      background: url('~@/assets/images/microsites/headingfortomorrow/hero/bg-mobile.jpg') no-repeat center bottom /
        100% auto;
    }
    .m-headingForT-hero__content {
      width: 95%;
      top: 15vw;
      left: 50%;
      transform: translateX(-50%);
    }
    .m-headingForT-hero__video {
      width: 70vw;
      height: 39vw;
      margin-bottom: 5vw;
    }
    .m-headingForT-hero__logo {
      width: 60vw;
    }
    .m-headingForT-hero__t {
      width: 100%;
      font-size: 4.3vw;
      margin-bottom: 3vw;
    }
    .m-headingForT-hero__patch-note-btns {
      flex-direction: column;
      left: 48vw;
      bottom: 47vw;
      gap: 3vw;
    }
    .m-headingForT-hero__patch-note-btn {
      width: 70vw;
      height: 9.5vw;
    }
    .m-headingForT-hero__scoll-iron {
      display: none;
    }
  }
</style>
